import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal-alerta',
  templateUrl: './modal-alerta.component.html',
  styleUrls: ['./modal-alerta.component.scss'],
})
export class ModalAlertaComponent {
  @Output() closeModalAlerta = new EventEmitter();
  @Input() mensaje!:string;
  @Input() titulo!:string;

  closeModal(emitValue: boolean = false) {
    this.closeModalAlerta.emit(emitValue);
  }
}
